import { render, staticRenderFns } from "./BillableTypeResource.vue?vue&type=template&id=73b113cd&"
import script from "./BillableTypeResource.vue?vue&type=script&lang=js&"
export * from "./BillableTypeResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports